import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import svg from "assets/images/sidebarActiveIcons/adviseMe.svg";
import {
  SidebarDashboard,
  SidebarDietPlan,
  SidebarExercise,
  SidebarSleepCoach,
  SidebarMindfulness,
  SidebarPreferences,
  SidebarAdviseMe,
  SidebarFaq,
  SidebarProgressTracker,
  SidebarMyAccount,
  SidebarFitboat,
  ActiveSidebarDashboard,
  ActiveSidebarDietPlan,
  ActiveSidebarExercise,
  ActiveSidebarSleepCoach,
  ActiveSidebarMindfulness,
  ActiveSidebarPreferences,
  ActiveSidebarAdviseMe,
  ActiveSidebarFaq,
  ActiveSidebarProgressTracker,
  ActiveSidebarMyAccount,
  ActiveSidebarFitboat,
  SidebarLogout,
  SideBarQuizGame,
  ActiveSidebarQuizGame,
  MotivationSidebarActive,
  MotivationSidebar,
  WeeklyProgressSidebar,
  ActiveWeeklyProgress,
  LogoNew,
  BackImg,
  ActiveContactUs,
  ContactUs,
  YourPlan,
  ActiveYourPlans,
  ActivePremiumFeatures,
  ActiveYourResults,
  ActiveSetup,
  ActiveSupport,
  PremiumFeatures,
  YourResults,
  SetupSidebar,
  Support,
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

const WORDPRESS_BASE_URL = process.env.REACT_APP_WORDPRESS_URL;

const Sidebar = ({ smallScreen = false, setDrawerOpen }) => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);
  const { t } = useTranslation();

  const menuItems = [
    {
      name: t("sidebar.dashboard"),
      path: "/",
      icon: <SidebarDashboard />,
      iconActive: ActiveSidebarDashboard,
    },
    {
      name: t("sidebar.Your Plans"),
      icon: <YourPlan />,
      iconActive: ActiveYourPlans,
      subItems: [
        {
          name: t("sidebar.dietPlan"),
          path: "/diet-plan",
          icon: <SidebarDietPlan />,
          iconActive: ActiveSidebarDietPlan,
        },
        {
          name: t("sidebar.exercisePlan"),
          path: "/exercise-plan",
          icon: <SidebarExercise />,
          iconActive: ActiveSidebarExercise,
        },
        {
          name: t("sidebar.sleepCoach"),
          path: "/sleep-coach",
          icon: <SidebarSleepCoach />,
          iconActive: ActiveSidebarSleepCoach,
        },
        {
          name: t("sidebar.mindfulness"),
          path: "/mindfulness",
          icon: <SidebarMindfulness />,
          iconActive: ActiveSidebarMindfulness,
        },
        {
          name: t("sidebar.Motivational Coach"),
          path: "/motivational-coach",
          icon: <MotivationSidebar />,
          iconActive: MotivationSidebarActive,
        },
        {
          name: t("sidebar.fitbotSupport"),
          path: "/fitbot-support",
          icon: <SidebarFitboat />,
          iconActive: ActiveSidebarFitboat,
        },
      ],
    },
    {
      name: t("sidebar.Premium Features"),
      icon: <PremiumFeatures />,
      iconActive: ActivePremiumFeatures,
      subItems: [
        {
          name: t("sidebar.quizGame"),
          path: "/quiz-game",
          icon: <SideBarQuizGame />,
          iconActive: ActiveSidebarQuizGame,
        },
      ],
    },
    {
      name: t("sidebar.Your Results"),
      icon: <YourResults />,
      iconActive: ActiveYourResults,
      subItems: [
        {
          name: t("sidebar.progressTracker"),
          path: "/progress-tracker",
          icon: <WeeklyProgressSidebar />,
          iconActive: ActiveWeeklyProgress,
        },
      ],
    },

    {
      name: t("sidebar.Setup"),
      icon: <SetupSidebar />,
      iconActive: ActiveSetup,
      subItems: [
        {
          name: t("sidebar.adviseMe"),
          path: "/advise",
          icon: <SidebarAdviseMe />,
          iconActive: ActiveSidebarAdviseMe,
        },
        {
          name: t("sidebar.preferences"),
          path: "/edit-preferences",
          icon: <SidebarPreferences />,
          iconActive: ActiveSidebarPreferences,
        },
        {
          name: t("sidebar.myAccount"),
          path: `${WORDPRESS_BASE_URL}/my-account/edit-account/`,
          icon: <SidebarMyAccount />,
          iconActive: ActiveSidebarMyAccount,
        },
      ],
    },

    {
      name: t("sidebar.Support"),
      icon: <Support />,
      iconActive: ActiveSupport,
      subItems: [
        {
          name: t("sidebar.faq"),
          path: `${WORDPRESS_BASE_URL}/user-faqs/`,
          icon: <SidebarFaq />,
          iconActive: ActiveSidebarFaq,
        },

        {
          name: t("sidebar.contactUs"),
          path: `/contact-us`,
          icon: <ContactUs />,
          iconActive: ActiveContactUs,
        },
      ],
    },

    // {
    //   name: t("sidebar.progressTracker"),
    //   path: "/progress-tracker",
    //   icon: <SidebarProgressTracker />,
    //   iconActive: ActiveSidebarProgressTracker,
    // },
  ];

  // Function to check if any sub-item is active
  const isSubItemActive = (subItems) => {
    if (!subItems) return false;

    return subItems.some((subItem) => {
      if (subItem.path === "/") {
        return (
          location.pathname === "/" ||
          location.pathname.startsWith("/dashboard")
        );
      }
      return location.pathname.startsWith(subItem.path);
    });
  };

  return (
    <div
      className="h-screen bg-cover  text-white flex flex-col py-6 px-4 overflow-y-auto"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <Link to="/">
        <img src={LogoNew} alt="logo" className="w-48" />
      </Link>

      <ul className="mt-4 space-y-1 flex-grow">
        {menuItems.map((item, index) => {
          const isParentActive = isSubItemActive(item.subItems);

          return (
            <li
              key={index}
              className="relative rounded"
              onMouseEnter={() => {
                setActiveMenu(index);
              }}
              onMouseLeave={() => setActiveMenu(null)}
            >
              {item.subItems ? (
                <Accordion
                  className={`bg-none p-0 ${
                    !isParentActive && "hover:bg-[#FFFFFF1A]"
                  }`}
                  sx={{
                    backgroundColor: "transparent",
                    boxShadow: "unset",
                    color: isParentActive ? "#0575E6" : "white",
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{ color: isParentActive ? "#0575E6" : "white" }}
                      />
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      margin: "0",
                      // minHeight: "unset",
                      backgroundColor: isParentActive ? "white" : "transparent",
                      borderRadius: "4px",
                      "& .MuiAccordionSummary-content": {
                        margin: "8px 0",
                      },
                      padding: "0px 6px",
                    }}
                  >
                    <div className="flex items-center gap-2">
                      <span>
                        {isParentActive ? (
                          <img
                            src={item.iconActive}
                            alt="sidebarIcon"
                            className="w-5 h-5"
                          />
                        ) : (
                          item.icon
                        )}
                      </span>
                      <span
                        className={
                          isParentActive ? "text-[#0575E6] font-semibold" : ""
                        }
                      >
                        {item.name}
                      </span>
                    </div>
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      padding: "8px 8px 8px 8px",
                      backgroundColor: "transparent", // Ensures the dropdown part isn't white
                    }}
                  >
                    <div className="ml-2 space-y-1">
                      {item.subItems.map((subItem, subIndex) => {
                        const isActive =
                          subItem.path === "/"
                            ? location.pathname === "/" ||
                              location.pathname.startsWith("/dashboard")
                            : location.pathname.startsWith(subItem.path);

                        return (
                          <Link
                            key={subIndex}
                            to={subItem.path}
                            className={`flex items-center gap-2 pl-2 pr-4 py-2 rounded transition ${
                              isActive
                                ? "bg-white text-[#0575e6] font-semibold"
                                : isParentActive
                                ? "hover:bg-[#FFFFFF1A] text-white" // Keep sub-items readable when parent is white
                                : "hover:bg-[#FFFFFF1A]"
                            }`}
                            onClick={() => {
                              if (smallScreen && setDrawerOpen) {
                                setDrawerOpen(false);
                              }
                            }}
                          >
                            <span>
                              {/* Force sub-item icons to be white/normal when background is dark */}
                              {isActive ? (
                                <img
                                  src={subItem.iconActive}
                                  alt="sidebarIcon"
                                  className="w-5 h-5"
                                />
                              ) : (
                                subItem.icon
                              )}
                            </span>
                            <span
                              className={`${
                                isActive ? "text-[#0575e6]" : "text-white"
                              }`}
                            >
                              {subItem.name}
                            </span>
                          </Link>
                        );
                      })}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ) : (
                // Regular menu items without sub-items
                <Link
                  to={item.path}
                  className={`flex items-center gap-2 pl-2 pr-4 py-2 rounded transition ${
                    location.pathname === item.path ||
                    (item.path === "/" &&
                      (location.pathname === "/" ||
                        location.pathname.startsWith("/dashboard"))) ||
                    (item.path !== "/" &&
                      location.pathname.startsWith(item.path))
                      ? "bg-[#F6F7FB]  text-[#1980e7] font-semibold"
                      : "hover:bg-[#FFFFFF1A]"
                  }`}
                  onClick={() => {
                    if (smallScreen && setDrawerOpen) {
                      setDrawerOpen(false);
                    }
                  }}
                >
                  <span>
                    {location.pathname === item.path ||
                    (item.path === "/" &&
                      (location.pathname === "/" ||
                        location.pathname.startsWith("/dashboard"))) ||
                    (item.path !== "/" &&
                      location.pathname.startsWith(item.path)) ? (
                      <img
                        src={item.iconActive}
                        alt="sidebarIcon"
                        className="w-5 h-5"
                      />
                    ) : (
                      item.icon
                    )}
                  </span>
                  <span
                    className={
                      location.pathname === item.path ||
                      (item.path === "/" &&
                        (location.pathname === "/" ||
                          location.pathname.startsWith("/dashboard"))) ||
                      (item.path !== "/" &&
                        location.pathname.startsWith(item.path))
                        ? "text-[#0575E6]"
                        : ""
                    }
                  >
                    {item.name}
                  </span>
                </Link>
              )}
            </li>
          );
        })}
      </ul>

      <Link
        to={"/logout"}
        className="w-full text-left px-4 py-2 mt-auto hover:bg-[#FFFFFF1A] rounded flex items-center gap-2 transition group"
      >
        <SidebarLogout />
        <span>{t("sidebar.logout")}</span>
      </Link>
    </div>
  );
};

export default Sidebar;
